import { toaster } from "@kobalte/core";
import type { ShowToastOptions } from "@kobalte/core/dist/types/toast/types";
import type { JSX } from "solid-js/jsx-runtime";
import { Match, Switch } from "solid-js/web";
import { ToastWrapper } from "./styled";
import type { ToastType } from "./types";

function show(message: JSX.Element, type: ToastType = "default", options?: ShowToastOptions) {
	return toaster.show(
		(props) => (
			<ToastWrapper toastId={props.toastId} toastType={type}>
				{message}
			</ToastWrapper>
		),
		options,
	);
}

function success(message: JSX.Element, type: ToastType = "success", options?: ShowToastOptions) {
	return toaster.show(
		(props) => (
			<ToastWrapper toastId={props.toastId} toastType={type}>
				{message}
			</ToastWrapper>
		),
		options,
	);
}
function error(message: JSX.Element, type: ToastType = "error", options?: ShowToastOptions) {
	return toaster.show(
		(props) => (
			<ToastWrapper toastId={props.toastId} toastType={type}>
				{message}
			</ToastWrapper>
		),
		options,
	);
}
function promise<T, U>(
	p: Promise<T> | (() => Promise<T>),
	options: {
		loading?: JSX.Element;
		success?: (data: T) => JSX.Element;
		error?: (error?: U) => JSX.Element;
	},
) {
	return toaster.promise(p, (props) => (
		<ToastWrapper
			toastId={props.toastId}
			toastType={props.state === "pending" ? "default" : props.state === "fulfilled" ? "success" : "error"}
		>
			<Switch>
				<Match when={props.state === "pending"}>{options.loading}</Match>
				<Match when={props.state === "fulfilled"}>{options.success?.(props.data as T)}</Match>
				<Match when={props.state === "rejected"}>{options.error?.(props.error)}</Match>
			</Switch>
		</ToastWrapper>
	));
}

function dismiss(id: number) {
	return toaster.dismiss(id);
}
export const toast = {
	show,
	success,
	error,
	promise,
	dismiss,
};
